import { action, observable, makeObservable } from "mobx";
import TaskTrackerAPI from "../api/TaskTracker";
import { GetTasksParams, Task } from "../models/TaskTracker/Task";
import { OrderProducts } from "../models/TaskTracker/OrderProducts";
import { Admin } from "../models/TaskTracker/Admin";

export class TaskTrackerStore {
  TaskTrackerAPI: TaskTrackerAPI;
  limit: number;
  total_pages: number;
  total_count: number;
  tasks: Task[] = [];
  orderIds: number[];
  products: OrderProducts[];
  admins: Admin[];
  taskDetails: Task | undefined;
  refreshStates: {
    taskTracker: boolean;
  };

  constructor() {
    this.TaskTrackerAPI = new TaskTrackerAPI();
    this.tasks = [];
    this.limit = 0;
    this.total_pages = 0;
    this.total_count = 0;
    this.orderIds = [];
    this.products = [];
    this.admins = [];
    this.taskDetails = {};
    this.refreshStates = {
      taskTracker: false,
    };

    makeObservable(this, {
      tasks: observable,
      orderIds: observable,
      products: observable,
      admins: observable,
      taskDetails: observable,
      getTasks: action,
      refreshStates: observable,
      setRefreshState: action,
      getProjectOrderIds: action,
    });
  }

  getTasks = async (params: GetTasksParams) => {
    try {
      const response = await this.TaskTrackerAPI.getTasks(params);
      this.limit = response.limit;
      this.total_pages = response.total_pages;
      this.total_count = response.total_count;
      this.tasks = response.list;
    } catch (error: any) {
      throw error;
    }
  };

  getProjectOrderIds = async (order_id: number) => {
    try {
      const response = await this.TaskTrackerAPI.getProjectOrders(order_id);
      this.orderIds = response.result || [];
    } catch (error: any) {
      throw error;
    }
  };

  getOrderProducts = async (order_id: number) => {
    try {
      const response = await this.TaskTrackerAPI.getProducts(order_id);
      this.products = response.result || [];
    } catch (error: any) {
      throw error;
    }
  };

  getAdminBySearch = async (name: string) => {
    try {
      const response = await this.TaskTrackerAPI.getAdmin(name);
      this.admins = response.result.list || [];
    } catch (error: any) {
      throw error;
    }
  };

  createTask = async (taskDetails: Task) => {
    try {
      const response = await this.TaskTrackerAPI.createTask(taskDetails);
      this.admins = response.result.list || [];
    } catch (error: any) {
      throw error;
    }
  };

  getTaskDetailsById = async (taskId: number) => {
    try {
      const response = await this.TaskTrackerAPI.getTaskDetails(taskId);
      this.taskDetails = response || {};
    } catch (error: any) {
      throw error;
    }
  };

  updateTaskDetails = async (updatedTask: Task) => {
    try {
      const response = await this.TaskTrackerAPI.updateTask(updatedTask);
      const updatedTaskDetails =
        response.result && typeof response.result === "object"
          ? { ...updatedTask, ...response.result }
          : updatedTask;

      if (this.taskDetails?.id === updatedTask.id) {
        this.taskDetails = { ...this.taskDetails, ...updatedTaskDetails };
      }

      const taskIndex = this.tasks.findIndex(
        (task) => task.id === updatedTask.id
      );
      if (taskIndex !== -1) {
        this.tasks[taskIndex] = {
          ...this.tasks[taskIndex],
          ...updatedTaskDetails,
        };
      }

      return response.result;
    } catch (error: any) {
      throw error;
    }
  };
  setRefreshState = (type: keyof typeof this.refreshStates, value: boolean) => {
    this.refreshStates[type] = value;
  };
  refreshTaskTracker = async (
    orderId: number,
    taskTrackerParams: {
      page_no: number;
      limit: number;
      sortBy: string;
      sortType: string;
      status?: number | null;
      owner_id?: number[];
      assignee_id?: number[];
      search_text?: string;
    },
    TaskTrackerStore: any
  ) => {
    if (!orderId) return;

    this.setRefreshState("taskTracker", true);

    try {
      await TaskTrackerStore?.getTasks({
        order_id: [orderId],
        page_no: taskTrackerParams.page_no,
        limit: taskTrackerParams.limit,
        sortBy: taskTrackerParams.sortBy,
        sortType: taskTrackerParams.sortType,
        status: taskTrackerParams.status
          ? [taskTrackerParams.status]
          : undefined,
        owner_id: taskTrackerParams.owner_id && taskTrackerParams.owner_id.length > 0
          ? taskTrackerParams.owner_id
          : undefined,
        assignee_id: taskTrackerParams.assignee_id && taskTrackerParams.assignee_id.length > 0
          ? taskTrackerParams.assignee_id
          : undefined,
        search_text: taskTrackerParams.search_text || undefined,
      });
    } catch (error) {
    } finally {
      setTimeout(() => {
        this.setRefreshState("taskTracker", false);
      }, 500);
    }
  };
}
